<template>
  <v-layout>
    <filtersMaster
      ref="filtersMaster"
      :select="select"
      :filtersdef="filtros"
      :options="options"
      @filter="filter"
      @loadSelectsData="loadSelectsData"
      @loadSelectProvincia="loadSelectProvincia"
      @loadSelectLocalidad="loadSelectLocalidad" />
  </v-layout>
</template>
<script>
import FiltersMaster from "@/components/datatable/Filters"; /** *******************************/
import tippy from "tippy.js";
import CombosAPI from "@/services/catalogos";

export default {
  name: "FiltersModule"
  , components: { FiltersMaster }
  , data() {
    return {
      init: true
      , view: { action: { submit: { busy: false } } }
      , select: {
        provincia: {
          completeList: []
          , filteredList: []
          , disabled: false
        }
        , localidad: {
          completeList: []
          , filteredList: []
          , disabled: false
        }
      }
      , filtros: {
        nombre: []
        , nombrePersonaContacto: []
        , cuit: []
        , provincia: []
        , localidad: []
        , status: []
      }
      , options: [
        {
          code: "nombre"
          , name: this.$t("view.operativos.seOOB.filters.nombre")
          , icon: "fas fa-store"
          , type: "multitext"
          , selected: ""
          , disabled: false
        }
        , {
          code: "nombrePersonaContacto"
          , name: this.$t("view.operativos.seOOB.filters.nombrePersonaContacto")
          , icon: "fas fa-phone"
          , type: "multitext"
          , selected: ""
          , disabled: false
        }
        , {
          code: "cuit"
          , name: this.$t("view.operativos.seOOB.filters.cuit")
          , icon: "fas fa-id-badge"
          , type: "multinumber"
          , selected: ""
          , disabled: false
        }
        , {
          code: "provincia"
          , name: this.$t("view.operativos.seOOB.filters.provincia")
          , icon: "fas fa-map"
          , type: "serverside"
          , selected: {}
          , disabled: false
        }
        , {
          code: "localidad"
          , name: this.$t("view.operativos.seOOB.filters.localidad")
          , icon: "fas fa-map-marker-alt"
          , type: "serverside"
          , selected: {}
          , disabled: false
        }
        , {
          code: "estatus"
          , name: this.$t("view.operativos.seOOB.filters.estatus")
          , icon: "fas fa-check"
          , type: "sino"
          , selected: false
          , disabled: false
        }
      ]
    };
  }
  , created() {
    this.$nextTick(() => tippy(".btn_tippy_menu", { arrow: true, size: "large", animation: "scale", placement: "left" }));
  }
  , methods: {
    filter(filtros) {
      this.$emit("filter", filtros);
    }
    , async loading(status = false) {
      this.view.action.submit.busy = status;
    }
    , async loadSelectsData() {}
    , async loadSelectProvincia(selected, value) {
      const { data: { results: { combo: provinciaList } } } = await CombosAPI.getSeverSide({ option: "ssprovincia", keyword: value });
      this.select[selected].filteredList = [...this.select[selected].filteredList, ...(provinciaList || [])];
      this.select[selected].completeList = [...this.select[selected].completeList, ...(provinciaList || [])];
    }
    , async loadSelectLocalidad(selected, value) {
      const { data: { results: { combo: localidadList } } } = await CombosAPI.getSeverSide({ option: "sslocalidad", keyword: value });
      this.select[selected].filteredList = [...this.select[selected].filteredList, ...(localidadList || [])];
      this.select[selected].completeList = [...this.select[selected].completeList, ...(localidadList || [])];
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.fab-container {
  position: fixed;
  top: 110px;
  right: 12px;
}
</style>



// WEBPACK FOOTER //
// src/views/operativos/seOOB/Filters.vue